export const FINAL_PAGE = {
  1: 'FinalPage_v1',
  2: 'FinalPage_v2',
  DEFAULT: 'FinalPage_v1'
}

export const FINAL_PAGE_CONTENT = {
  1: 'final-page_v1',
  2: 'final-page_v2',
  default: 'final-page_v1'
}
